import React, { use, useCallback, useEffect, useState } from "react";
import Playtable from "./Playtable";
import { Modal, ProgressBar } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Slider from "./Slider";
import "./play.scss";
import Balance from "../../hooks/dataFetcher/BalanceOf";
import { useWeb3React } from "@web3-react/core";
import TotalLiquidity from "../../hooks/dataFetcher/TotalLiquidity";
import PlaceBet from "../../hooks/dataSender/PlaceBet";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import { useApprove } from "../../hooks/dataSender/Approval";
import ResolveBet from "../../hooks/dataSender/ResolveBet";
import PendingBet from "../../hooks/dataFetcher/PendingBet";
import Web3 from "web3";
import Loader from "../../hooks/loader";
import { callGraphQLQuery } from "../../utils/axiosClient";
import useWeb3 from "../../hooks/useWeb3";
import SqurtPrice from "../../hooks/dataFetcher/squrtPrice";
import SqurtPriceV4 from "../../hooks/dataFetcher/squrtPriceV4";
import { wait } from "@testing-library/user-event/dist/cjs/utils/index.js";
import BigNumber from "bignumber.js";
import { random } from "lodash";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import {
  userSmartAccount,
  userSmartAccountClient,
  usePermisions,
  useSmartSession,
  useEthInternalBalace,
} from "../../components/recoilAtom";
import { useRecoilValue } from "recoil";
import {
  CRASH_GAME_CONTRACT,
  USDT_CONTRACT_ADDRESS,
  LUCKIFY_CONTRACT_ADDRESS,
} from "../../utils/Enviroment";
import { getLiquidityPool } from "../../utils/contractHelpers";
import CashOut from "../../hooks/dataSender/cashout";
import WalletConnectModel from "../walletConnectModel";
import { toast } from "react-toastify";
import { useSessionPermissions } from "../../hooks/checkSessionPermissions";
import showToast from "../../hooks/showToast";
import BuyBackBurn from "../../hooks/dataFetcher/buyBack&Burn";
const Play = () => {
  const { baughtBackhook } = BuyBackBurn();
  const [theme, setTheme] = useState("light");
  const [show11, setShow11] = useState(false);

  const handleClose11 = () => setShow11(false);
  const handleShow11 = () => setShow11(true);
  const { PlaceBetLuckHook } = CashOut();
  // const web3 = useWeb3();
  const smartAccount = useRecoilValue(userSmartAccount);
  const meClient = useRecoilValue(userSmartAccountClient);
  // const session = useRecoilValue(useSmartSession);
  // const permission = useRecoilValue(usePermisions);
  const ethinternalBlce = useRecoilValue(useEthInternalBalace);
  const uniswapUrl =
    "https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x5bc247A5fc7DC148b682787C58f6f764ce27581b";
  // console.log(ethinternalBlce, "ethinternalBlce");
  const web3 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );

  const { BalanceHook } = Balance();
  const { grantPermissions } = useSessionPermissions();

  const { TotalLiquidityHook, TotalWinningHook, TotalVolumeHook, JackpotHook } =
    TotalLiquidity();
  const { SqurtPriceHoodV4 } = SqurtPriceV4();
  const { SqurtPriceHood } = SqurtPrice();
  const { PlaceBetHook } = PlaceBet();
  const { ResolveBetHook } = ResolveBet();
  const { checkAllowance } = useCheckAllowance();
  const { PendingBetHook } = PendingBet();
  const approvee = useApprove();

  let { account } = useWeb3React();
  const [showbet, setShowbet] = useState(false);

  const handleClosebet = () => setShowbet(false);
  const handleShowbet = () => setShowbet(true);

  const [showbet1, setShowbet1] = useState(false);

  const handleClosebet1 = () => setShowbet1(false);
  const handleShowbet1 = () => setShowbet1(true);

  const [showbet2, setShowbet2] = useState(false);

  const handleClosebet2 = () => setShowbet2(false);
  const handleShowbet2 = () => setShowbet2(true);
  const [PnL, setPnl] = useState(0);
  const [showbet3, setShowbet3] = useState(false);
  const [pendingBets, setPendingBet] = useState(false);
  const [tokenPriceContract, setTokenPriceContract] = useState(0);
  const [sessionStore, setSessionStore] = useState();
  const handleClosebet3 = () => {
    window.location.reload();
    setShowbet3(false);
    handleClosebet2();
    setShowbet3(false);
    setSelectedOdds(1);
    setInputAmount("");
    fetchEthBalance();
  };
  const handleShowbet3 = () => setShowbet3(true);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const [inputAmount, setInputAmount] = useState("");
  const [errorMessages, setErrorMessages] = useState("");
  const [userBalance, setUserBalance] = useState(null);
  const [currentLiquidity, setCurrentLiquidity] = useState(null);
  const [totalWinnings, setTotalWinnings] = useState(null);
  const [totalVolume, setTotalVolume] = useState(null);
  const [jacpot, setJackPot] = useState(null);
  const [baughtBack, setbaughtBack] = useState(null);
  const [maxBet, setMaxBet] = useState(null);
  const [selectedOdds, setSelectedOdds] = useState(1);
  const [potentialPayout, setPotentialPayout] = useState(0);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isModalOneButtonDisabled, setIsModalOneButtonDisabled] =
    useState(true);
  const [winningsHistory, setWinningsHistory] = useState([]);
  const [result, setResult] = useState(false);
  const [randomNumber, setRandomNumber] = useState(null);
  const [betHistory, setBetHistory] = useState([]);
  const [latestBetHistory, setLatestBetHistory] = useState([]);
  const [latestBetHistory1, setLatestBetHistory1] = useState([]);
  const [betHistory1, setBetHistory1] = useState([]);
  const [payout, setPayout] = useState(0);

  const handleOddsChange = useCallback((newOdds) => {
    setSelectedOdds(newOdds);
  }, []);

  const fetchBetHistory = async () => {
    setLoading(true);
    const query = `
      query GetResolvedBets {
       betResolveds(orderBy: blockTimestamp, orderDirection: desc){
  won
  player
  payout
  amount
  odds
  transactionHash
  blockTimestamp
}
      }
    `;

    try {
      const data = await callGraphQLQuery(query);
      setWinningsHistory(data?.betResolveds);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOwnerBetHistory = async () => {
    const query = `
      query GetResolvedBets {
        betResolveds(orderDirection: desc,orderBy: blockTimestamp ,where: { player: "${smartAccount}" }) {
          transactionHash
          amount
          odds
          random
          payout
          blockTimestamp
          won
        }
      }
    `;

    try {
      const data = await callGraphQLQuery(query);
      setBetHistory(data?.betResolveds);
      setLatestBetHistory(data?.betResolveds[0]);

      const totalPayout = data?.betResolveds.reduce((sum, bet) => {
        return (
          sum +
          parseFloat(web3.utils.fromWei(String(bet?.payout || "0"), "mwei"))
        );
      }, 0);

      const totalAmount = data?.betResolveds.reduce((sum, bet) => {
        return (
          sum +
          parseFloat(web3.utils.fromWei(String(bet?.amount || "0"), "mwei"))
        );
      }, 0);

      const netProfit = totalPayout - totalAmount;
      setPnl(netProfit);

      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
      setLoading(false);
    }
  };

  const fetchOwnerBetHistory1 = async () => {
    // setLoading(true);
    const query = `
      query GetResolvedBets {
        betResolveds(orderDirection: desc,orderBy: blockTimestamp ,where: { player: "${smartAccount}" }) {
          transactionHash
          amount
          odds
          random
          payout
          blockTimestamp
          won
        }
      }
    `;

    try {
      const data = await callGraphQLQuery(query);
      return data;
      // setLatestBetHistory1(data?.betResolveds[0]);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch bet history:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!pendingBets) {
      if (inputAmount > 0 && selectedOdds > 0 && selectedOdds <= 100) {
        const betAmount = parseFloat(inputAmount);
        const oddsPercentage = parseFloat(selectedOdds) / 100; // Convert 20% to 0.20

        if (isNaN(betAmount) || isNaN(oddsPercentage) || oddsPercentage === 0) {
          setPotentialPayout(0);
          return;
        }

        const fee = betAmount * 0.05; // 5% fee
        const netBet = betAmount - fee;
        const calculatedGrossWin = netBet / oddsPercentage;

        setPotentialPayout(calculatedGrossWin?.toFixed(2)); // Format to 2 decimal places
      } else {
        setPotentialPayout(0); // Reset if inputs are invalid for calculation
      }
    }
  }, [inputAmount, selectedOdds]);

  const isSubmitDisabled = () => {
    return (
      !smartAccount ||
      inputAmount > userBalance ||
      inputAmount < 1 || // Checks if the input amount is less than 1
      inputAmount > maxBet || // Checks if the input amount exceeds the maximum bet
      selectedOdds <= 1 || // Checks if the selected odds are not greater than 1
      userBalance == 0 ||
      null // Checks if the user balance is zero
    );
  };

  const handleInputAmount = (e) => {
    const input = parseFloat(e.target.value);
    setErrorMessages("");
    if (!isNaN(input)) {
      if (userBalance == 0 || input > userBalance) {
        setErrorMessages("Insufficient balance.");
        setInputAmount(input);
      }
      if (input < 1) {
        setErrorMessages("Amount must be at least $1.");
        setInputAmount(input);

        // return;
      } else if (input > maxBet) {
        setErrorMessages("Input amount exceeds maximum bet.");
        // return
        setInputAmount(input);
      } else {
        setInputAmount(input);
      }
    } else {
      setInputAmount("");
    }
  };
  useEffect(() => {
    let timerInterval = null;

    const checkBlockDifference = async () => {
      try {
        const ResolveBetTx = await PendingBetHook(smartAccount);
        console.log(ResolveBetTx.blockPlaced, "ResolveBetTx");

        const currentBlock = await web3.eth.getBlockNumber();
        console.log(currentBlock, "ResolveBetTx");
        const blockDiff = currentBlock - parseInt(ResolveBetTx.blockPlaced);
        console.log(currentBlock, "ResolveBetTx");
        console.log(blockDiff, "blockDiff");
        if (ResolveBetTx?.timestampPlaced === "0") {
          let bb = await fetchOwnerBetHistory1();

          if (bb?.betResolveds?.length > betHistory?.length) {
            setLatestBetHistory1(bb?.betResolveds[0]);
            setProgress(100);

            handleClosebet1();
            handleShowbet3();

            // setTimeout(() => {
            //   handleShowbet3();
            // }, 8000);
            // }
            //   console.log("pendingBetchecking", ResolveBetTx);
            // } else if (blockDiff === 1) {
            //   setProgress(10);
            // } else if (blockDiff === 2) {
            //   setProgress(20);
            // } else if (blockDiff === 3) {
            //   setProgress(30);
            // } else if (blockDiff === 4) {
            //   setProgress(40);
            // } else if (blockDiff === 5) {
            //   setProgress(50);
            // } else if (blockDiff === 6) {
            //   setProgress(60);
            // } else if (blockDiff === 7) {
            //   setProgress(70);
            // } else if (blockDiff === 8) {
            //   setProgress(80);
            // } else if (blockDiff === 9) {
            //   setProgress(90);
            // } else {
            //   setProgress(0);
            // }
          } else {
            setProgress(95);
          }
        } else {
          setProgress(50);
        }
      } catch (err) {
        console.error("Error fetching block number:", err);
      }
    };

    if (showbet1) {
      // Initial state
      // setProgress(0);
      setIsModalOneButtonDisabled(true);

      // Start interval
      timerInterval = setInterval(() => {
        checkBlockDifference();
      }, 3000); // every 3 seconds
    }

    // Cleanup on unmount or showbet1 change
    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [showbet1, web3, smartAccount]);

  // useEffect(() => {
  //   let timerInterval = null;
  //   if (showbet1) {
  //     // Reset states when modal becomes visible
  //     setTimeLeft(30);
  //     setProgress(0);
  //     setIsModalOneButtonDisabled(true);

  //     timerInterval = setInterval(() => {
  //       setTimeLeft((prevTime) => {
  //         const newTime = prevTime - 1;
  //         if (newTime <= 0) {
  //           clearInterval(timerInterval);
  //           setIsModalOneButtonDisabled(false);
  //           setProgress(100); // Ensure progress is full
  //           return 0;
  //         }
  //         // Calculate progress based on time elapsed
  //         setProgress(((30 - newTime) / 30) * 100);
  //         return newTime;
  //       });
  //     }, 1000);
  //   } else {
  //     // Cleanup if modal is hidden (e.g., closed by user)
  //     if (timerInterval) {
  //       clearInterval(timerInterval);
  //     }
  //   }

  //   return () => {
  //     // Ensure interval is cleared when component unmounts or showbet1 changes before interval completion
  //     if (timerInterval) {
  //       clearInterval(timerInterval);
  //     }
  //   };
  // }, [showbet1]);

  const fetchEthBalance = async () => {
    try {
      const balance = await BalanceHook(smartAccount);
      setUserBalance(balance);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };
  useEffect(() => {
    if (smartAccount) {
      fetchEthBalance();
    }
  }, [smartAccount]);

  const fetchData = async () => {
    try {
      const liquidity = await TotalLiquidityHook(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS
      );
      const winnings = await TotalWinningHook(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS
      );
      const volume = await TotalVolumeHook(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS
      );
      const jackPot = await JackpotHook(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS
      );
      const baughtBack = await baughtBackhook(
        getLiquidityPool,
        LUCKIFY_CONTRACT_ADDRESS
      );
      setCurrentLiquidity(liquidity);
      setTotalWinnings(winnings);
      setTotalVolume(volume);
      setJackPot(jackPot);
      setbaughtBack(baughtBack);
      const calculateMaxBet = (liquidity / 95 / 5).toFixed(2);
      setMaxBet(calculateMaxBet);
    } catch (error) {
      console.error("Error fetching ETH balance:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchBetHistory();
  }, [smartAccount]);

  useEffect(() => {
    fetchOwnerBetHistory();
  }, [smartAccount]);
  const handleBet = async () => {
    setLoading(true);
    const betAmount = parseFloat(inputAmount);
    const oddsPercentage = parseFloat(selectedOdds);
    try {
      setLoaderText({
        heading: "Checking Pending Bets",
        paragraph: "Please approve transaction for placing bet...",
      });
      setPendingBet(true);
      const Pending = await PendingBetHook(smartAccount);
      const placedTimeMs = Number(Pending.timestampPlaced) * 1000; // Convert to milliseconds
      const now = Date.now();
      const timeDiff = now - placedTimeMs;
      if (timeDiff < 20 * 60 * 1000) {
        const inputamountusd = web3.utils.fromWei(Pending?.amount, "mwei");
        setInputAmount(inputamountusd);
        setSelectedOdds(Pending?.odds); // 5% fee
        const netBet = inputamountusd;
        const calculatedGrossWin = (netBet / Pending?.odds) * 100;
        setPotentialPayout(calculatedGrossWin?.toFixed(2));
        handleClosebet();
        handleShowbet2();
        setLoaderText({
          heading: "",
          paragraph: "",
        });
        setLoading(false);
        return;
      }
      const checkUserAllowance = await checkAllowance(
        smartAccount,
        LUCKIFY_CONTRACT_ADDRESS
      );
      console.log(checkUserAllowance, "checkUserAllowance", smartAccount);

      console.log(checkUserAllowance, "checkUserAllowance");

      if (checkUserAllowance < betAmount) {
        setLoaderText({
          heading: "Placing your bet.",
          paragraph: "Please approve transaction for placing bet...",
        });
        const { userPermissions: permissions, userSessionKey: sessionKey } =
          await grantPermissions();

        const betTx = await PlaceBetLuckHook(
          inputAmount,
          selectedOdds,
          true,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        {
          setLoaderText({
            heading: "",
            paragraph: "",
          });
          if (betTx) {
            setLoading(false);
            handleShowbet1();
            handleClosebet();
          }
          return betTx;
        }
      } else {
        setLoaderText({
          heading: "Placing your bet.",
          paragraph: "Please approve transaction for placing bet...",
        });
        const { userPermissions: permissions, userSessionKey: sessionKey } =
          await grantPermissions();

        const betTx = await PlaceBetLuckHook(
          inputAmount,
          selectedOdds,
          true,
          smartAccount,
          meClient,
          permissions,
          sessionKey
        );
        setLoaderText({
          heading: "",
          paragraph: "",
        });
        if (betTx) {
          setLoading(false);
          handleShowbet1();
          handleClosebet();
        }
      }
    } catch (error) {
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      setLoading(false);
      console.error("Error placing bet:", error);
    }
  };

  const handleResolveBet = async () => {
    setLoading(true);
    setLoaderText({
      heading: "Resolving Your bet",
      paragraph:
        "Please confirm your transaction before revealing the result...",
    });
    try {
      const ResolveBetTx = await ResolveBetHook();
      setRandomNumber(ResolveBetTx?.events?.BetResolved?.returnValues?.random);
      setResult(ResolveBetTx?.events?.BetResolved?.returnValues?.won);
      const resultPayout = web3.utils.fromWei(
        ResolveBetTx?.events?.BetResolved?.returnValues?.payout,
        "mwei"
      );
      setPayout(resultPayout);
      setLoading(false);
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      handleShowbet3();
      handleClosebet1();
      handleClosebet2();
      setPendingBet(false);
    } catch (error) {
      setLoading(false);
      setLoaderText({
        heading: "",
        paragraph: "",
      });
      console.error("Error Resolving bet:", error);
    }
  };

  useEffect(() => {
    if (showbet3 !== true) return;

    const audio = new Audio(
      latestBetHistory1?.won ? "/assets/win.mp3" : "/assets/lost.mp3"
    );
    audio.play().catch((e) => {
      console.error("Audio play failed:", e);
    });

    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [showbet3, latestBetHistory1]);

  const handerAutomodel = async () => {
    const Pending = await PendingBetHook(smartAccount);
    const now = Date.now();
    const placedTimeMs = Number(Pending.timestampPlaced) * 1000; // Convert to milliseconds
    const timeDiff = now - placedTimeMs;
    if (timeDiff < 20 * 60 * 1000) {
      const inputamountusd = web3.utils.fromWei(Pending?.amount, "mwei");
      setInputAmount(inputamountusd);
      setSelectedOdds(Pending?.odds); // 5% fee
      const netBet = inputamountusd;
      const calculatedGrossWin = (netBet / Pending?.odds) * 100;
      setPotentialPayout(calculatedGrossWin.toFixed(2));

      handleShowbet1();
    }
  };

  const tokenPrice = async () => {
    try {
      // let value = await SqurtPriceHood();
      // let value = await SqurtPriceHoodV4();

      // let balace = await axios.get(
      //   "https://min-api.cryptocompare.com/data/price?fsym=BNB&tsyms=USD"
      // );
      // const sqrtPriceX96 = new BigNumber(value);
      // const Q96 = new BigNumber(2).exponentiatedBy(96); // Alternative to pow()

      // const priceX96 = sqrtPriceX96.times(sqrtPriceX96); // Alternative to multipliedBy()
      // const denominator = Q96.times(Q96);
      // const numerator = priceX96.times("1000000000000000000");

      // const price = numerator.dividedBy(denominator).toNumber();
      // let pric1 = price / 10 ** 18;
      // let final = balace.data.USD * pric1;
      // setTokenPriceContract(final);
      let balace = await axios.get(
        "https://min-api.cryptocompare.com/data/price?fsym=LUCK&tsyms=USD"
      );

      setTokenPriceContract(balace.data.USD);
      // console.log(balace.data.USD / pric1, balace, pric1, "ddsfsfsdfs");
    } catch (err) {
      console.log(err, "err in pool");
    }
  };

  useEffect(() => {
    // if (account) {
    //   handerAutomodel();
    // }
    tokenPrice();
  }, [smartAccount]);

  const location = useLocation();
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "dark";
    setTheme(storedTheme);
    document.documentElement.setAttribute("data-theme", storedTheme);
  }, []);

  return (
    <>
      <WalletConnectModel
        theme={theme}
        show={show11}
        handleClose={handleClose11}
      />
      {loading && <Loader text={loaderText} />}
      <section className="mainplay">
        <div className="custom-container">
          <div className="mainodds mt-0">
            <p className="oddspara">Dice</p>
            {/* <div className="navlinks">
              <Link
                to="/play"
                className={
                  location.pathname === "/play" ? "navlink active" : "navlink"
                }
              >
                Play
              </Link>
              <Link
                to="/liquidity"
                className={
                  location.pathname === "/liquidity"
                    ? "navlink active"
                    : "navlink"
                }
              >
                Liquidity
              </Link>
            </div> */}
          </div>
          <div className="innerplay">
            <div className="leftgrid ordertwo">
              <div className="leftupper">
                <div className="upperinner full-width">
                  <p className="innerpara">Current Liquidity</p>
                  <h6 className="innerhead">
                    ${(+currentLiquidity)?.toFixed(2)}
                  </h6>
                </div>
                <div className="upperinner full-width">
                  <p className="innerpara">Total PnL</p>
                  {/* <h6 className="innerhead">
             -- --
                  </h6> */}
                  <h6
                    className={`innerhead ${
                      PnL >= 0 ? "greentext" : "redText"
                    }`}
                  >
                    ${PnL?.toFixed(2)}
                  </h6>
                </div>
                <div className="upperinner half-width">
                  <p className="innerpara">Total Winnings</p>
                  <h6 className="innerhead maininnerhead">
                    ${(+totalWinnings)?.toFixed(2)}
                  </h6>
                </div>
                <div className="upperinner half-width borderright">
                  <p className="innerpara">Total Volume</p>
                  <h6 className="innerhead maininnerhead">
                    ${(+totalVolume)?.toFixed(2)}
                  </h6>
                </div>
              </div>
              <div className="leftbottom">
                <h6 className="statshead">$LUCK Stats</h6>
                <div className="statsinnermain">
                  <div className="statsinner">
                    <p className="statpara">Bought Back & Burned</p>
                    <h6 className="statheading">
                      {(+baughtBack)?.toFixed(2)} lUCK{" "}
                      <img src="/assets/playassets/luck.svg" alt="tokenimg" />
                    </h6>
                  </div>
                  <div className="statsinner">
                    <p className="statpara">Token Price</p>
                    <h6 className="statheading">
                      $
                      {tokenPriceContract?.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 5,
                      })}
                      {/* <p className="greenpara">+42.34%</p> */}
                    </h6>
                  </div>
                </div>
                <Nav.Link
                  href={uniswapUrl} // Use href prop
                  target="_blank"
                  rel="noopener noreferrer"
                  className="buybtn"
                >
                  Buy $LUCK
                </Nav.Link>
              </div>
            </div>
            <div className="midgrid orderone">
              <h6 className="midhead">Play the Game</h6>
              <div className="midparas">
                <p className="innerpara">
                  <span className="dullpara">Min Bet</span> $1
                </p>
                <p className="innerpara">
                  <span className="dullpara">Max Bet</span> ${maxBet}
                </p>
              </div>
              <div className="inputheader">
                <p className="betpara">Bet Amount</p>
                <h6 className="balancepara">
                  <span className="dullpara">Balance:</span>{" "}
                  {(+userBalance)?.toFixed(2)} USDC
                </h6>
              </div>
              <div className="maininput">
                <input
                  type="number"
                  placeholder="0.00"
                  className="innerinput"
                  value={inputAmount}
                  onChange={handleInputAmount}
                  inputMode="decimal"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
                <div className="maintokenimg">
                  <img
                    src="\assets\playassets\usdc.svg"
                    alt="tokenimg"
                    className="tokenimg"
                  />
                  <img
                    src="\assets\playassets\base.svg"
                    alt="baseimg"
                    className="baseimg"
                  />
                </div>

                {errorMessages && (
                  <p
                    style={{
                      marginTop: "10px",
                      color: "red",
                      fontSize: "12px",
                    }}
                    className="error"
                  >
                    {errorMessages}
                  </p>
                )}
              </div>
              <p className="oddspara">Pick Your Odds</p>
              <Slider
                value={selectedOdds} // Pass selectedOdds as the current value
                onValueChange={handleOddsChange}
              />
              <div className="middetails">
                <div className="midinner">
                  <p className="midpara">Your Odds</p>
                  <h6 className="percentagepara">{selectedOdds}%</h6>
                </div>
                <div className="midinner">
                  <p className="midpara">Your Payout</p>
                  <h6 className="amountpara">${potentialPayout}</h6>
                </div>
              </div>
              {smartAccount ? (
                <button
                  disabled={isSubmitDisabled()}
                  onClick={handleShowbet}
                  className="betbtn"
                >
                  Bet
                </button>
              ) : (
                <button onClick={handleShow11} className="betbtn">
                  Connect Wallet
                </button>
              )}
            </div>
            <div className="rightgrid orderthree">
              <div className="rightupper">
                <p className="currentpara">
                  Current Jackpot
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M6 1C8.7615 1 11 3.2385 11 6C11 8.7615 8.7615 11 6 11C3.2385 11 1 8.7615 1 6C1 3.2385 3.2385 1 6 1ZM6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2ZM6 8C6.13261 8 6.25979 8.05268 6.35355 8.14645C6.44732 8.24021 6.5 8.36739 6.5 8.5C6.5 8.63261 6.44732 8.75979 6.35355 8.85355C6.25979 8.94732 6.13261 9 6 9C5.86739 9 5.74021 8.94732 5.64645 8.85355C5.55268 8.75979 5.5 8.63261 5.5 8.5C5.5 8.36739 5.55268 8.24021 5.64645 8.14645C5.74021 8.05268 5.86739 8 6 8ZM6 3.25C6.42114 3.25001 6.82913 3.39668 7.15389 3.6648C7.47865 3.93292 7.69991 4.30577 7.77965 4.71929C7.8594 5.13281 7.79266 5.56119 7.59089 5.93086C7.38913 6.30052 7.06493 6.58838 6.674 6.745C6.6161 6.76629 6.5639 6.80069 6.5215 6.8455C6.4995 6.8705 6.496 6.9025 6.4965 6.9355L6.5 7C6.49986 7.12744 6.45106 7.25002 6.36358 7.34268C6.27609 7.43535 6.15652 7.49112 6.0293 7.49859C5.90208 7.50605 5.77681 7.46466 5.67908 7.38287C5.58136 7.30107 5.51855 7.18505 5.5035 7.0585L5.5 7V6.875C5.5 6.2985 5.965 5.9525 6.302 5.817C6.43916 5.76223 6.5588 5.67113 6.64809 5.55349C6.73738 5.43585 6.79294 5.29611 6.8088 5.14928C6.82466 5.00244 6.80022 4.85406 6.73811 4.72007C6.676 4.58608 6.57857 4.47153 6.45627 4.38874C6.33397 4.30594 6.19143 4.25803 6.04395 4.25013C5.89648 4.24224 5.74963 4.27467 5.6192 4.34394C5.48876 4.4132 5.37965 4.51669 5.3036 4.64329C5.22754 4.76989 5.1874 4.91481 5.1875 5.0625C5.1875 5.19511 5.13482 5.32229 5.04105 5.41605C4.94729 5.50982 4.82011 5.5625 4.6875 5.5625C4.55489 5.5625 4.42771 5.50982 4.33395 5.41605C4.24018 5.32229 4.1875 5.19511 4.1875 5.0625C4.1875 4.5818 4.37846 4.12078 4.71837 3.78087C5.05828 3.44096 5.5193 3.25 6 3.25Z"
                      fill="#606367"
                    />
                  </svg>
                </p>
                <h6 className="currentnumber">${(+jacpot)?.toFixed(2)}</h6>
              </div>
              <div className="rightbottom">
                <div className="bottomhead">
                  <h6 className="headpara">Winning Odds</h6>
                </div>
                <div className="bettingdetails">
                  {winningsHistory
                    .filter((bet) => bet?.won == true)
                    .map((bet) => (
                      <div className="mainbet">
                        <div className="betleft">
                          <span className="betnumber">{bet?.odds}%</span>
                          <p className="betpara">
                            <span className="greenpara">Won</span> $
                            {bet?.payout
                              ? parseFloat(
                                  web3.utils.fromWei(String(bet.payout), "mwei")
                                ).toFixed(2)
                              : "0.00"}
                            on a bet of ${" "}
                            {(() => {
                              const betAmountInEther = parseFloat(
                                web3?.utils?.fromWei(
                                  String(bet?.amount),
                                  "mwei"
                                )
                              );
                              return betAmountInEther.toFixed(2);
                            })()}{" "}
                            {/* {parseFloat(
                              web3.utils.fromWei(String(bet?.amount), "mwei")
                            ).toFixed(2)} */}
                          </p>
                        </div>
                        <a
                          href={`https://basescan.org/tx/${bet?.transactionHash}`}
                          className="innerlink"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_175_238)">
                              <path
                                d="M10.5 6.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H5.5"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.5 1.5L6 6"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M7.5 1.5H10.5V4.5"
                                stroke="#3E3F43"
                                stroke-width="1.04"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_175_238">
                                <rect width="12" height="12" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </a>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <Playtable randomNumber={randomNumber} betHistory={betHistory} />
        </div>
      </section>

      <Modal
        className="betmodal"
        show={showbet}
        onHide={handleClosebet}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Bet Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="innerbox">
            <div className="parentbetbox">
              <div className="innerbet">
                <p>Bet Amount</p>
                <h6>${inputAmount - 0.05 * inputAmount}</h6>
              </div>
              <div className="innerbet">
                <p>Your Odds</p>
                <h6 className="purple">{selectedOdds}%</h6>
              </div>

              <div className="innerbet">
                <p>Payout if you win</p>
                <h6>${potentialPayout}</h6>
              </div>
            </div>
          </div>
          <div className="twicebutton">
            <button
              onClick={() => {
                handleClosebet();
              }}
              className="close"
            >
              Close
            </button>
            <button
              className="confirm"
              onClick={() => {
                handleBet();
              }}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="betmodal"
        show={showbet1}
        onHide={handleClosebet1}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>bet placed successfully!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="upperhead">Generating a Random Number</h4>
          <p className="para">
            Waiting for the blockchain to generate a random number.
          </p>
          <div className="cardprogress">
            <ProgressBar
              now={progress}
              animated
              label={`${Math.round(progress)}%`}
            />
          </div>
          <div className="innerbox">
            <div className="parentbetbox">
              <div className="innerbet">
                <p>Bet Amount</p>
                <h6>${inputAmount - 0.05 * inputAmount}</h6>
              </div>
              <div className="innerbet">
                <p>Your Odds</p>
                <h6 className="purple">{selectedOdds}%</h6>
              </div>

              <div className="innerbet">
                <p>Payout if you win</p>
                <h6>${potentialPayout}</h6>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="betmodal"
        show={showbet2}
        onHide={handleClosebet2}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>reveal the results</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4 className="upperhead">Ready to see if you won?</h4>
          <p className="para">
            Click the button below to reveal the random number. You will win if
            the number is equal to or lower than 25
          </p>

          <div className="innerbox">
            <div className="parentbetbox">
              <div className="innerbet">
                <p>Bet Amount</p>
                <h6>${inputAmount - 0.05 * inputAmount}</h6>
              </div>
              <div className="innerbet">
                <p>Your Odds</p>
                <h6 className="purple">{selectedOdds}%</h6>
              </div>

              <div className="innerbet">
                <p>Payout if you win</p>
                <h6>${potentialPayout}</h6>
              </div>
            </div>
          </div>
          <div className="twicebutton">
            <button
              className="confirm"
              onClick={() => {
                handleResolveBet();
              }}
            >
              Reveal the results
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="betmodal"
        show={showbet3}
        onHide={handleClosebet3}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {latestBetHistory1?.won ? "Congrats!" : "Oh-no!"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {latestBetHistory1?.won ? (
            <h4 className="upperhead">You won the bet 🎉</h4>
          ) : (
            <h4 className="upperhead">You Lost the bet!</h4>
          )}

          {latestBetHistory1?.won ? (
            <img src="/assets/won.gif" alt="wongif" className="mainbetimage" />
          ) : (
            <img
              src="/assets/lost.gif"
              alt="lostgif"
              className="mainbetimage"
            />
          )}
          <div className="smallmainbox">
            <p className="maininnerpara">The generated number is</p>
            {latestBetHistory1?.won ? (
              <p className="bluepara">{latestBetHistory1?.random}</p>
            ) : (
              <p className="redpara">{latestBetHistory1?.random}</p>
            )}
          </div>

          <div className="innerbox ">
            <div className="parentbetbox">
              <div className="innerbet">
                <p>Bet Amount</p>
                <h6>${(inputAmount - 0.05 * inputAmount).toFixed(2)} </h6>
              </div>
              <div className="innerbet formarginmain">
                <p>Your Odds</p>
                <h6 className="purple">{latestBetHistory1?.odds}%</h6>
              </div>
            </div>
          </div>
          {latestBetHistory1?.won && (
            <div className="lowerbox">
              <p className="wonpara">You Won</p>
              <h6 className="texttt">
                $
                {latestBetHistory1?.payout &&
                  parseFloat(
                    web3.utils.fromWei(
                      String(latestBetHistory1?.payout),
                      "mwei"
                    )
                  ).toFixed(2)}{" "}
              </h6>
            </div>
          )}
          <p className="bottompara">
            {latestBetHistory1?.won
              ? "Your winnings have been transferred to your wallet."
              : "Better luck next time!"}
          </p>
          <div className="twicebutton">
            <button
              onClick={() => {
                handleClosebet3();
              }}
              className="close"
            >
              Close
            </button>
            <button
              onClick={() => {
                handleClosebet3();
              }}
              className="confirm"
            >
              Play Again
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Play;
